.contactHref {
    text-decoration: underline !important;
}

.contactCss {

    --contact-color: var(--cs-primary-dark);

    & * {
        color: var(--contact-color);
    }
}